const SPLIT_RANK: Record<string, number> = {
  winter: 0,
  spring: 1,
  summer: 2,
  fall: 3,
};

const parseSeason = (season: string): { year: number; split: string; rank: number } | null => {
  const match = /^(\d{4})-([a-z]+)$/i.exec(season.trim());
  if (!match) return null;
  const split = match[2].toLowerCase();
  return {
    year: Number(match[1]),
    split,
    rank: SPLIT_RANK[split] ?? -1,
  };
};

/**
 * Turns a season slug into a readable label ("2024-fall" → "Fall 2024").
 * Slugs with an unknown shape or split are shown as-is.
 */
export const formatSeasonName = (season: string, splitLabels: Record<string, string>): string => {
  const parsed = parseSeason(season);
  if (!parsed) return season;

  const label = splitLabels[parsed.split.toUpperCase()];
  return label ? `${label} ${String(parsed.year)}` : season;
};

/** Negative when `a` is newer than `b` (for `.sort(compareSeasonsDesc)`). */
export const compareSeasonsDesc = (a: string, b: string): number => {
  const pa = parseSeason(a);
  const pb = parseSeason(b);
  if (!pa && !pb) return b.localeCompare(a);
  if (!pa) return 1;
  if (!pb) return -1;
  if (pa.year !== pb.year) return pb.year - pa.year;
  return pb.rank - pa.rank;
};

export const sortSeasonsDesc = (seasons: string[]): string[] =>
  [...seasons].sort(compareSeasonsDesc);
